module.exports = __webpack_public_path__ + "static/media/Collections-Outdoor-Experiences-Desktop.b5bebd16.webp";